import { StateObject } from "../../../../redux/types"
import { getSelectedTerminalIds, getSettingsByKey, handleTerminalSettingFormItem } from "../../selectors"

export const getGratuityDefaultValues = (
    state: StateObject
): { defaultEnabled: boolean; overrideIndeterminate: boolean } => {
    // Check whether the GRATUITY_ENABLED setting already exists with true/false value
    const gratuitySettingValue = handleTerminalSettingFormItem(state, "GRATUITY_ENABLED", "other", null)
    if (gratuitySettingValue?.GRATUITY_ENABLED?.value != null) {
        // If the setting exists, return the value
        return {
            defaultEnabled: gratuitySettingValue.GRATUITY_ENABLED.value,
            overrideIndeterminate: false,
        }
    }

    // If the setting is not yet created, deduct the default values from other, related settings.
    const selectedTerminalIds = getSelectedTerminalIds(state)
    const minGuestSettings = getSettingsByKey(state, "MINIMAL_GUEST_COUNT_FOR_AUTOMATIC_GRATUITY").filter(
        s => s.terminal_id && selectedTerminalIds.includes(s.terminal_id)
    )
    const autoGratuitySettings = getSettingsByKey(state, "AUTOMATIC_GRATUITY_PERCENTAGE_VALUE").filter(
        s => s.terminal_id && selectedTerminalIds.includes(s.terminal_id)
    )

    const someGratuityEnabled =
        minGuestSettings.some(s => s.value && s.value !== "0") ||
        autoGratuitySettings.some(s => s.value && s.value !== "0")

    const someGratuityDisabled = selectedTerminalIds.some(id => {
        const minGuest = minGuestSettings.find(s => s.terminal_id === id)
        const autoGratuity = autoGratuitySettings.find(s => s.terminal_id === id)
        return (
            !minGuest ||
            !autoGratuity ||
            !minGuest.value ||
            !autoGratuity.value ||
            (minGuest.value === "0" && autoGratuity.value === "0")
        )
    })

    const gratuityEnabledDefault = someGratuityEnabled && !someGratuityDisabled
    const overrideIndeterminate = someGratuityEnabled && someGratuityDisabled

    return {
        defaultEnabled: gratuityEnabledDefault,
        overrideIndeterminate: overrideIndeterminate,
    }
}
